import App from "./App.vue";
import { createApp } from "vue";
import { Buffer } from "buffer";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";

import store from "~/store";
import router from "~/router";
import i18n from "~/plugins/i18n";
import "~/store/modules/projects";
import "~/plugins";

// Vue.config.productionTip = false;
// Vue.config.devtools = true;
// main.js
import VSwatches from "vue3-swatches";
import "vue3-swatches/dist/style.css";

import { AlertPlugin } from "~/plugins/AlertPlugin";

import { createPinia } from "pinia";
import VueApexCharts from 'vue3-apexcharts';


globalThis.Buffer = Buffer;

const app = createApp(App);
const vuetify = createVuetify({
  theme: {
    typography: {
      htmlFontSize: 10,
    },
  },
});
app.use(VSwatches);

app
  .use(AlertPlugin)
  .use(i18n)
  .use(vuetify)
  .use(router)
  .use(VueApexCharts)
  .use(createPinia())
  .use(store)


  .mount("#app");
